module.exports = __webpack_public_path__ + "static/media/icon_quanly_email.d7c321a4.svg";